import { useMemo } from 'react'

import { useWindowResize } from '@utils/domUtils'

import { CurrencyType } from '@model/WalletDto'

import { DXTRADE_POSITION_EFFECT } from '../../utils/constants'
import { useDxtradeCashTransfers } from '../hooks/useDxtradeCashTransfers'
import type { HistoryOrderWithLots } from '../hooks/useHistoryOrdersWithLots'
import { buildOvernightFeesMap, parseFinancingTransfers } from '../utils/DxtradeCashTransfersFields'
import { CardHistoryView } from './CardHistoryView'
import { HistoryOrdersTable } from './HistoryOrdersTable'

type Props = {
  orders: HistoryOrderWithLots[]
  isLoading: boolean
  accountCurrency?: CurrencyType
  accountCode?: string
  hasActiveFilters?: boolean
}

export function HistoryTab({
  orders,
  isLoading,
  accountCurrency,
  accountCode,
  hasActiveFilters,
}: Props) {
  const isMobile = useWindowResize()
  const { data: cashTransfersData } = useDxtradeCashTransfers(accountCode ?? '')

  const parsedTransfers = useMemo(
    () => parseFinancingTransfers(cashTransfersData?.cashTransfers),
    [cashTransfersData?.cashTransfers]
  )

  const overnightFeesMap = useMemo(() => {
    const positionIds = orders.flatMap((order) => {
      const code = order.legs?.[0]?.positionCode
      return order.legs?.[0]?.positionEffect === DXTRADE_POSITION_EFFECT.CLOSE && code ? [code] : []
    })

    return buildOvernightFeesMap(parsedTransfers, positionIds)
  }, [parsedTransfers, orders])

  return (
    <>
      {isMobile ? (
        <CardHistoryView
          orders={orders}
          isLoading={isLoading}
          accountCurrency={accountCurrency}
          overnightFeesMap={overnightFeesMap}
          hasActiveFilters={hasActiveFilters}
        />
      ) : (
        <HistoryOrdersTable
          orders={orders}
          isLoading={isLoading}
          accountCurrency={accountCurrency}
          overnightFeesMap={overnightFeesMap}
          hasActiveFilters={hasActiveFilters}
        />
      )}
    </>
  )
}
